import api from "APP_ROOT/api";
import * as actionTypes from "./actionTypes";
import { SUCCESS } from "../../lib/submission";

export function show(id) {
  return dispatch =>
    api.rejectedCores.show(id).then(resp => {
      dispatch({
        type: actionTypes.SET,
        rejectedCore: resp.data
      });
    });
}

export function update(data) {
  return (dispatch, getState) => {
    const id = getState().rejectedCoreDetail.getIn(["rejectedCore", "id"]);

    return api.rejectedCores.update(id, data).then(({ data: rejectedCore }) => {
      dispatch({ type: actionTypes.SET, rejectedCore });
      return SUCCESS;
    });
  };
}



// WEBPACK FOOTER //
// ./app/modules/RejectedCores/actions.js